import React, { useCallback, useState } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { usePageStartBootstrap } from '../hooks/use_page_start_bootstrap';
import { processError } from '../utils/base_error';
import { useDependencyInjection } from '../../config/di/dependency_injection_context';
import { usePageLoader } from '../contexts/page_content_context';
import { DataAuditoriaDropDown } from '../domain/models/data_auditoria_dropdown';

type Props = {
  name: string;
  label?: string;
  newButtonLabel?: string;
  required?: boolean;
  readOnly?: boolean;
  placeholder?: string;
  disabled?: boolean;
  value: string | number | null | undefined; 
  onChange: (newValue: string | number | undefined) => void; 
  error?: boolean;
  helperText?: string | null;
};

export const DefaultDataAuditoria = ({
  name,
  label,
  required,
  readOnly,
  placeholder,
  disabled,
  value,
  onChange,
  error,
  helperText,

}: Props) => {

  const { pushErrorNotification, pushInfoNotification } = usePageLoader();
  const [dataAuditoriaDropDown, setDataAuditoriaDropDown] = useState<DataAuditoriaDropDown[]>([]);

  const {
    commons: {
      getDataAuditoriaDropDownUseCase,
    },
  } = useDependencyInjection();

  const loadFornecedorDropDown = useCallback(async () => {
    try {
      const result = await getDataAuditoriaDropDownUseCase.getDataAuditoriaDropDown();
      setDataAuditoriaDropDown(result);
    } catch (e: unknown) {
      pushErrorNotification('Error', processError(e, 'Falha ao buscar nomes do auditores!'));
    }
  }, [getDataAuditoriaDropDownUseCase, pushErrorNotification]);

  usePageStartBootstrap(async () => {
    loadFornecedorDropDown();
  });


  return (
    <>
     <Autocomplete
        fullWidth={true}
        size="small"
        disablePortal
        options={dataAuditoriaDropDown}
        getOptionLabel={(opt) => String(opt.dataAuditoria)}
        isOptionEqualToValue={(opt, val) => String(opt.dataAuditoria) === String(val.dataAuditoria)} 
        sx={{ minHeight: 45 }}
        readOnly={readOnly}
        disabled={disabled}
        value={dataAuditoriaDropDown.find(x => String(x.dataAuditoria) === String(value)) ?? null}
        onChange={(_, newValue) => {
          onChange(newValue ? newValue.dataAuditoria : undefined);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            size="small"
            label={label}
            error={error}
            helperText={helperText}
            placeholder={placeholder}
            required={required}
          />
        )}
      />
    </>
  );
};